import { UserAssetRuleListAction } from '@kaltura-ott/ott-client-types/api/types';
import { KalturaUserAssetRuleFilter } from '@kaltura-ott/ott-client-types/api/types/KalturaUserAssetRuleFilter';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { kalturaClient } from './kaltura-clent';

export const getUserRules = (assetIdEqual: number, assetTypeEqual: 0 | 1) => {
  const action = new UserAssetRuleListAction({
    filter: new KalturaUserAssetRuleFilter({
      assetIdEqual,
      assetTypeEqual,
    }),
  });
  const client = kalturaClient();
  return client.request(action).pipe(
    map((ruleObject) => {
      return ruleObject.objects;
    }),
    catchError((error) => {
      return throwError(error);
    }),
  );
};
